/*
	Отправка сообщения в чат с текущим session_id
	Прием сообщения от сервера
*/
import wsClient from "../core/wsClient";
import { IChatMessagePayload } from "../../types/chat.type";
import { ISessionMessage } from "../../types/session.type";
import { store } from "../../store/store";
import { appendMessage } from "../../store/slices/session.slice";
import queryClient from "../../query/queryClient";

export const chatService = {
	sendMessage(payload: IChatMessagePayload) {
		wsClient.sendMessage(payload);
	},

	loadMoreHistory(sessionId: string, cursor: string | null) {
		wsClient.send("history.load_more", { sessionId, cursor });
	},

	assistantMessage(payload: ISessionMessage) {
		store.dispatch(appendMessage(payload));
		queryClient.invalidateQueries({ queryKey: ["sessions-data"] });
	},
};
